var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c("div", {
    class: _vm.$route.name != "newShopping" ? _vm.$route.name == "newShopIndex" ? "" : "i-frame" : ""
  }, [_vm.ready ? _c("iframe", {
    class: _vm.$route.name != "newShopping" ? _vm.$route.name == "newShopIndex" ? "new-newShopIndex-iframe" : "i-frame-iframe" : "new-shopping-iframe",
    attrs: {
      scrolling: _vm.$route.name == "newShopIndex" || _vm.$route.name == "qrCodePage" ? "no" : "auto",
      id: "iframePage",
      src: _vm.src,
      frameborder: "0"
    }
  }) : _vm._e()]);
};

var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };